import React from 'react';
import PropTypes from 'prop-types';
import { Card, Button, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import FalconCardHeader from 'components/common/FalconCardHeader';
import Flex from 'components/common/Flex';

const MainContentCard = props => {
  //If no header is provided, use title or default to null
  const header = props.header
    ? props.header
    : props.title
    ? { title: props.title, titleTag: 'h5' }
    : null;
  const footer = props.footer;

  return (
    <Card className="h-md-100" {...props.attributes}>
      {header &&
        (header.html ? (
          <Card.Header
            className={header.className ? header.className : 'pb-0'}
            dangerouslySetInnerHTML={{
              __html: header.html
            }}
          />
        ) : (
          <FalconCardHeader
            title={header.title}
            titleTag={header.titleTag}
            titleClass={header.titleClass}
            className={header.className ? header.className : 'py-2'}
            light
            endEl={
              <Flex>
                <></>
                {header.links
                  ? header.links.map((link, index) => (
                      <Button
                        key={index}
                        variant="link"
                        size="sm"
                        as={Link}
                        className="me-2"
                        to={link.url}
                      >
                        {link.text}
                      </Button>
                    ))
                  : null}
              </Flex>
            }
          />
        ))}
      <Card.Body {...props.bodyAttributes}>{props.children}</Card.Body>
      {footer &&
        (footer.html ? (
          <Card.Footer
            className={
              footer.className
                ? footer.className
                : 'd-flex justify-content-between bg-light'
            }
            dangerouslySetInnerHTML={{
              __html: footer.html
            }}
          />
        ) : (
          <Card.Footer
            className={footer.className ? footer.className : 'bg-light py-2'}
          >
            <Row
              className={
                footer.rowClassName
                  ? footer.rowClassName
                  : 'flex-between-center'
              }
            >
              {footer.links.map((link, index) => (
                <Col xs="auto" key={index}>
                  <Link className="fs--1 font-sans-serif" to={link.url}>
                    {link.text}
                  </Link>
                </Col>
              ))}
            </Row>
          </Card.Footer>
        ))}

      {/**
        <Card.Footer className="d-flex justify-content-between bg-light">
          <div className="fw-semi-bold">Payable Total</div>
          <div className="fw-bold">AAA</div>
        </Card.Footer>
         */}
    </Card>
  );
};

MainContentCard.propTypes = {
  title: PropTypes.string,
  header: PropTypes.object,
  footer: PropTypes.object,
  attributes: PropTypes.object, //Card attributes
  bodyAttributes: PropTypes.object, //Card.Body attributes
  children: PropTypes.any
};

export default MainContentCard;
